import { styled } from '@volkswagen-onehub/components-core';
import { Checkmark, CheckboxCheckmark } from '@volkswagen-onehub/icons-core';
import React from 'react';

type Props = {
  size?: "default" | "medium" | "small" | "large";
  color?: string;
  title?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
  tabIndex?: 0 | -1;
  ref?: React.Ref<SVGElement>
};

const CheckmarkWrapper = styled.div<Props>`
  ${({size, color}) => {
    let size1;
    let size2;
    switch (size) {
      case 'medium':
        size1 = '20px';
        size2 = '24px';
        break;
      case 'small':
        size1 = '14px';
        size2 = '18px';
        break;
      default:
        size1 = '24px';
        size2 = '28px';
    }
    return `
      width: ${size1};
      height: ${size1};
      display: grid;
      justify-content: center;
      align-content: center;
      border: 2px solid ${color};
      border-radius: 50%;
      position: relative;
      &::before {
        content: "";
        width: ${size2};
        height: ${size2};
        background-color: #FFF;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: -1;
      }
    `;
  }}
`;

const StyledCheckmark = styled(Checkmark)<Props>`
  color: ${props => props.color};
`;

const StyledCheckboxCheckmark = styled(CheckboxCheckmark)<Props>`
  color: ${props => props.color};
`;

const CheckmarkBadge = styled.div<Props>`
  ${({ size }) =>
    size === "large"
    ? `transform: scale(1.3);`
    : undefined
  }
`;

const CheckmarkIcon = (props: Props) => props.size === "medium" ? <StyledCheckmark variant="small" {...props} /> : <StyledCheckboxCheckmark variant="default" {...props} />

export const Check = ({
  size = "default",
  color = "#001E50",
  title,
  ariaHidden,
  ariaLabel,
  tabIndex,
  ref
}: Props) => {

  return (
    <CheckmarkBadge
      size={size}
    >
      <CheckmarkWrapper
        size={size}
        color={color}
      >
        <CheckmarkIcon
          color={color}
          title={title}
          ariaHidden={ariaHidden}
          ariaLabel={ariaLabel}
          tabIndex={tabIndex}
          ref={ref}
        />
      </CheckmarkWrapper>
    </CheckmarkBadge>
  );
};
